import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const TeaserBig = () => {
  if (document.querySelectorAll('.teaser-big-section').length < 1) {
    return;
  }

  const contentBox = document.querySelector('.teaser-big-section .content-box');

  function createParallaxTimeline(triggerSelector, startYPercent, endYPercent, scaleTo) {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: triggerSelector,
            scrub: 1,
            pin: false,
        }
    });

    tl.fromTo(triggerSelector, {
        yPercent: startYPercent,
        scale: 1,
        ease: 'none'
    }, {
        yPercent: endYPercent,
        scale: scaleTo,
        ease: 'none'
    });

    return tl;
  }

  function parallaxEffect() {
    contentBox ? createParallaxTimeline(contentBox, -8, 8, 1) : null;
  }

  parallaxEffect();
};

export default TeaserBig;